import React from "react";
import "./btn-bleu.scss";
import PropTypes from "prop-types";

const BtnBleu = (props) => {
  return (
    <button
      className="btn-bleu"
      onClick={props.btnAction}
      disabled={props.loading || props.disabled}
      type={props.type}
    >
      {props.iconLeft ? (
        <>
          {props.children}
          {props.btnTexte}
        </>
      ) : (
        <>
          {props.btnTexte}
          {props.children}
        </>
      )}
    </button>
  );
};

BtnBleu.defaultProps = {
  disabled: false,
  loading: false,
  type: "submit",
};

BtnBleu.propTypes = {
  btnAction: PropTypes.func,
  btnTexte: PropTypes.string,
  children: PropTypes.any,
  iconLeft: PropTypes.bool,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  type: PropTypes.string,
};

export default BtnBleu;
